import script from "./CustomEdge.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomEdge.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__